<script>
import LogoComponent from "@/components/LogoComponent.vue";
import SideImage from "@/components/SideImage.vue";

export default {
  name: "HomeView",
  components: { LogoComponent, SideImage },
};
</script>

<template>
  <v-row align="center" style="height: 100%">
    <v-col cols="12" md="6" lg="6" class="ma0 pa-0 d-none d-md-block">
      <SideImage />
    </v-col>
    <v-col cols="12" md="6" lg="6">
      <v-row class="d-flex justify-center" align="center">
        <v-col cols="12" md="12" lg="12" class="d-flex justify-center">
          <LogoComponent />
        </v-col>
        <v-col cols="12" md="6">
          <div class="text-center">
            <v-btn
              id="next"
              rounded
              color="primary"
              width="50%"
              elevation="0"
              dark
              class="mt-9"
              href="/v1/register"
            >
              التالي</v-btn
            >
          </div>
        </v-col></v-row
      ></v-col
    >
  </v-row>
</template>

<style>
/* html,
body {
  overflow: hidden;
} */
</style>
